'use client';

import React from 'react';
import type { BoxProps } from '@mui/material/Box';
import Box from '@mui/material/Box';

interface Props extends React.PropsWithChildren<BoxProps> {
  pushContent?: boolean;
  pushHeader?: boolean;
  pushHeaderSizes?: BoxProps['pt'];
}

const MainLayout = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    pushContent = true,
    pushHeader = false,
    pushHeaderSizes = { xs: '43px', md: '46px' },
    children,
    ...rest
  } = props;

  return (
    <Box
      pt={pushHeader ? pushHeaderSizes : undefined}
      pl={pushContent ? { md: '280px' } : undefined}
      width="100%"
      height="100%"
      minHeight="100%"
      {...rest}
      ref={ref}
    >
      {children}
    </Box>
  );
});

export default MainLayout;
